"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import { Button, TypographyH4, TypographyText } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  onRetry: () => void;
};

const GameLoadError: FC<Props> = ({ onRetry }) => {
  const { t } = useGamePageData();

  return (
    <div
      data-testid="game-load-error"
      className="absolute inset-0 flex flex-col items-center justify-center gap-2 rounded-lg bg-secondary/80 p-6 text-center backdrop-blur"
    >
      <TypographyH4 isBold>
        {t("game.error.title", "This game couldn't load")}
      </TypographyH4>
      <TypographyText>
        {t("game.error.description", "Check your connection and try again.")}
      </TypographyText>
      <Button className="mt-2" onClick={onRetry}>
        {t("game.error.retry", "Retry")}
      </Button>
    </div>
  );
};

export default GameLoadError;
